// HUB-614: whether the app shell should still show its loading screen instead of choosing
// between the login form and the signed-in app.
//
// While PersistQueryClientProvider restores the saved shop-floor cache, TanStack Query does not
// start the `/api/auth/me` fetch, so the query reports "not loading" with no user. Treating that
// as "signed out" drew the login form, then the loading screen once the fetch began, then a new,
// empty login form: anything typed into the first form was lost. Restoring counts as loading.
export interface IdentityLoadingState {
  /** A held identity (sign-out or identity recovery in flight) keeps the current screen mounted. */
  identityHeld: boolean;
  /** The `/api/auth/me` query's own `isLoading`. */
  queryLoading: boolean;
  /** `useIsRestoring()` from the persisted query client. */
  cacheRestoring: boolean;
}

export function isIdentityLoading({ identityHeld, queryLoading, cacheRestoring }: IdentityLoadingState): boolean {
  if (identityHeld) return false;
  return queryLoading || cacheRestoring;
}
